import { createSlice } from "@reduxjs/toolkit";

const initialInterview = {
  date: "",
  trackingDate: "",
  explanation: ""
};

const initialStudentPreInterview = {
  term: 0,
  studentName: "",
  studentSurname: "",
  studentSchool: "",
  parentName: "",
  parentSurname: "",
  parentPhone: "",
  date: "",
  trackingDate: "",
  explanation: ""
};

const initialStudentPreInterviewState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  personnels: [],
  interview: initialInterview,
  studentPreInterview: initialStudentPreInterview
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const studentPreInterviewSlice = createSlice({
  name: "studentPreInterviews",
  initialState: initialStudentPreInterviewState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getInterviews
    interviewsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getPersonnels
    personnelsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.personnels = entities;
    },
    //getStudentPreInterview
    preInterviewFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.studentPreInterview = action.payload.entity;
    },
    //getInterview
    interviewFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.interview = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanListState
    listStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    },
    //cleanInterviewsState
    interviewStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.interview = initialInterview;
    },    
    //cleanStudentPreInterviewsState
    preInterviewStateCleaned: (state) => {
      state.studentPreInterview = initialStudentPreInterview;
    }
  }
});